//Node Modules
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../.././../store/Actions/actions";
import cloneDeep from "lodash.clonedeep";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import classnames from "classnames";
//Custom React Components
import Popup from "../../Modal/Popup";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import Counter from "../../Tool/Counter/Counter";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";

//Styles
import "./AccordionSettings.scss";
import "../Column/Column.scss";

//JS
import * as UTILS from "../../../utils/Utils";

const AccordionItemSettings = (props) => {

  const [state, setState] = useState({ activeTab: "1", showSettings: false });
  useEffect(() => {
    if (state.activeTab === undefined) {
      setState({ ...state, activeTab: "1" });
    }
  }, [state.activeTab, props]);
  const toggle = (tab) => {
    if (state.activeTab !== tab) {
      setState({ ...state, activeTab: tab });
    }
  };
  const addTitle = (e) => {
    let titleValue = e.target.value;
    let layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.element.id,
      (item) => {
        item.columnSettings[props.accordionItem].itemHeader.title = titleValue;
      },
      (colItem) => {
        colItem.columnSettings[props.accordionItem].itemHeader.title =
          titleValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };
  const setHeaderTextColor = (e, deviceType) => {
    let colorValue = e.rgb;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.color = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.color = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.color = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.color = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const selectHeaderFont = (e, deviceType) => {
    let selectedFont = e.target.value;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.fontFamily = selectedFont;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.fontFamily = selectedFont;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.fontFamily = selectedFont;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.fontFamily = selectedFont;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setFontSize = (e, deviceType) => {
     e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let selectedFontSize =
      e.target.value === ""
        ? 0
        : e.target.value < 0
        ? 0
        : e.target.value > 100
        ? 100
        : e.target.value;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.fontSize = selectedFontSize;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.fontSize = selectedFontSize;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.fontSize = selectedFontSize;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.fontSize = selectedFontSize;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setFontWeight = (e, deviceType) => {
    let fontWeightValue = e.target.checked;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.fontBold = fontWeightValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.fontBold = fontWeightValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.fontBold = fontWeightValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.fontBold = fontWeightValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setHeaderBackgroundColor = (e, deviceType) => {
    let colorValue = e.rgb;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.backgroundColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.backgroundColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.backgroundColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.backgroundColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setExpandedHeaderBackgroundColor = (e, deviceType) => {
    let colorValue = e.rgb;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.expandedBackgroundColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.expandedBackgroundColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.expandedBackgroundColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.expandedBackgroundColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const setHeaderBorderColor = (e, deviceType) => {
    let colorValue = e.rgb;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.borderColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.borderColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.borderColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.borderColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setBorderWidth = (e, deviceType, action) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let desktopValue =
      action === "plus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .desktopStyle.borderWidth
          ) + 1
        : action === "minus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .desktopStyle.borderWidth
          ) - 1
        : Number(e.target.value);
    let mobileValue =
      action === "plus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .mobileStyle.borderWidth
          ) + 1
        : action === "minus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .mobileStyle.borderWidth
          ) - 1
        : Number(e.target.value);
 desktopValue = desktopValue < 0 ? 0 : desktopValue > 30 ? 30 : desktopValue;
 mobileValue = mobileValue < 0 ? 0 : mobileValue > 30 ? 30 : mobileValue;

    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.borderWidth = desktopValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.borderWidth = desktopValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.borderWidth = mobileValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.borderWidth = mobileValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const setBorderRadius = (e, deviceType, action) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let desktopValue =
      action === "plus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .desktopStyle.borderRadius
          ) + 1
        : action === "minus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .desktopStyle.borderRadius
          ) - 1
        : Number(e.target.value);
    let mobileValue =
      action === "plus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .mobileStyle.borderRadius
          ) + 1
        : action === "minus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .mobileStyle.borderRadius
          ) - 1
        : Number(e.target.value);
   desktopValue =
     desktopValue < 0 ? 0 :  desktopValue > 30 ? 30 : desktopValue;
   mobileValue = mobileValue < 0 ? 0 : mobileValue > 30 ? 30 : mobileValue;

    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.borderRadius = desktopValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.borderRadius = desktopValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.borderRadius = mobileValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.borderRadius = mobileValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const setHeaderPadding = (e, deviceType, action, property) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let desktopValue =
      action === "plus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .desktopStyle[property]
          ) + 1
        : action === "minus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .desktopStyle[property]
          ) - 1
        : Number(e.target.value);
    let mobileValue =
      action === "plus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .mobileStyle[property]
          ) + 1
        : action === "minus"
        ? Number(
            props.element.columnSettings[props.accordionItem].itemHeader
              .mobileStyle[property]
          ) - 1
        : Number(e.target.value);
      desktopValue = desktopValue < 0 ? 0 : desktopValue;
      mobileValue = mobileValue < 0 ? 0 : mobileValue;

    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[props.accordionItem].itemHeader.desktopStyle[
            property
          ] = desktopValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle[property] = desktopValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[props.accordionItem].itemHeader.mobileStyle[
            property
          ] = mobileValue;
        },
        (colItem) => {
          colItem.columnSettings[props.accordionItem].itemHeader.mobileStyle[
            property
          ] = mobileValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const setBodyPadding = (e, deviceType, action, property) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
   let desktopValue =
     action === "plus"
       ? Number(
           props.element.columnSettings[props.accordionItem].itemBody
             .desktopStyle[property]
         ) + 1
       : action === "minus"
       ? Number(
           props.element.columnSettings[props.accordionItem].itemBody
             .desktopStyle[property]
         ) - 1
       : Number(e.target.value);
   let mobileValue =
     action === "plus"
       ? Number(
           props.element.columnSettings[props.accordionItem].itemBody
             .mobileStyle[property]
         ) + 1
       : action === "minus"
       ? Number(
           props.element.columnSettings[props.accordionItem].itemBody
             .mobileStyle[property]
         ) - 1
       : Number(e.target.value);
   desktopValue = desktopValue < 0 ? 0 : desktopValue;
   mobileValue = mobileValue < 0 ? 0 : mobileValue;


    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[props.accordionItem].itemBody.desktopStyle[
            property
          ] =
           desktopValue
        },
        (colItem) => {
          colItem.columnSettings[props.accordionItem].itemBody.desktopStyle[
            property
          ] = desktopValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[props.accordionItem].itemBody.mobileStyle[
            property
          ] =
           mobileValue
        },
        (colItem) => {
          colItem.columnSettings[props.accordionItem].itemBody.mobileStyle[
            property
          ] =
            mobileValue
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setBodyBackgroundColor = (e, deviceType) => {
    let colorValue = e.rgb;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemBody.desktopStyle.backgroundColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemBody.desktopStyle.backgroundColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemBody.mobileStyle.backgroundColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemBody.mobileStyle.backgroundColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const toggleHeaderPaddingUnit = (e) => {
    let widthUnit = e.target.value;

    let layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.element.id,
      (item) => {
        item.columnSettings[props.accordionItem].itemHeader.paddingUnit =
          widthUnit;
      },
      (colItem) => {
        colItem.columnSettings[props.accordionItem].itemHeader.paddingUnit =
          widthUnit;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };
  const toggleBodyPaddingUnit = (e) => {
    let widthUnit = e.target.value;

    let layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.element.id,
      (item) => {
        item.columnSettings[props.accordionItem].itemBody.paddingUnit =
          widthUnit;
      },
      (colItem) => {
        colItem.columnSettings[props.accordionItem].itemBody.paddingUnit =
          widthUnit;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const setIconColor = (e, deviceType) => {
    let colorValue = e.rgb;
    let layout = cloneDeep(props.layout);
    if (deviceType == "desktop") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.iconColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.desktopStyle.iconColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.iconColor = colorValue;
        },
        (colItem) => {
          colItem.columnSettings[
            props.accordionItem
          ].itemHeader.mobileStyle.iconColor = colorValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  return (
    <>
      <div className="accordionItem-Settings">
        <span
          onClick={() => {
            setState({
              showSettings: !state.showSettings,
            });
          }}
        >
          Accordion Item Settings
        </span>
      </div>
      {state.showSettings || (props.openAccordionItemSettingsIndex == props.col) ? (
        <Popup
          width="700"
          header="Accordion Item Settings"
          close={() => {
            setState({
              showSettings: !state.showSettings,
            });
           props.toggleAccordionItemSettings(null);
          }}
        >
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: state.activeTab === "1",
                })}
                onClick={() => {
                  toggle("1");
                }}
              >
                Header
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: state.activeTab === "2",
                })}
                onClick={() => {
                  toggle("2");
                }}
              >
                Body
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={state.activeTab}>
            <TabPane tabId="1">
              <div className="modalScrollContainerSecondary">
                <div className="modalContentWrapper">
                  <label htmlFor="row-label">Accordion Item Title</label>
                  <input
                    onChange={addTitle}
                    value={
                      props.element.columnSettings[props.accordionItem]
                        .itemHeader.title
                    }
                    className="accordion-label-input"
                    placeholder="Add Accordion Label"
                    type="text"
                  />
                </div>
                <div
                  className="padding-section"
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  <div className="heading">Header Title</div>
                </div>
                <div
                  className="d-flex modalContentWrapper"
                  style={{ columnGap: "5px" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Desktop</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div className="d-block">
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Text Color"
                            colorValue={
                              props.element.columnSettings[
                                `${props.accordionItem}`
                              ].itemHeader.desktopStyle.color
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setHeaderTextColor(e, "desktop");
                            }}
                          />
                        </div>
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Collapse Icon Color"
                            colorValue={
                              props.element.columnSettings[
                                `${props.accordionItem}`
                              ].itemHeader.desktopStyle.iconColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setIconColor(e, "desktop");
                            }}
                          />
                        </div>
                        <label>Font Family</label>
                        <select
                          onChange={(e) => {
                            selectHeaderFont(e, "desktop");
                          }}
                          value={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.fontFamily
                          }
                          style={{ width: "300px" }}
                        >
                          {UTILS.googleFonts.map((font, index) => {
                            return (
                              <option key={index} value={font.format}>
                                {font.name}
                              </option>
                            );
                          })}
                        </select>
                        <label>Font Size</label>
                        <input
                          style={{ width: "300px" }}
                          type="number"
                          value={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.fontSize
                          }
                          onChange={(e) => {
                            setFontSize(e, "desktop");
                          }}
                        />

                        <label>Font Bold</label>

                        <input
                          type="checkbox"
                          name="fontWeight"
                          checked={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.fontBold
                          }
                          onChange={(e) => {
                            setFontWeight(e, "desktop");
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Mobile</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div className="d-block">
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Text Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemHeader.mobileStyle.color
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setHeaderTextColor(e, "mobile");
                            }}
                          />
                        </div>
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Collapse Icon Color"
                            colorValue={
                              props.element.columnSettings[
                                `${props.accordionItem}`
                              ].itemHeader.mobileStyle.iconColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setIconColor(e, "mobile");
                            }}
                          />
                        </div>
                        <label>Font Family</label>
                        <select
                          onChange={(e) => {
                            selectHeaderFont(e, "mobile");
                          }}
                          value={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.fontFamily
                          }
                          style={{ width: "300px" }}
                        >
                          {UTILS.googleFonts.map((font, index) => {
                            return (
                              <option key={index} value={font.format}>
                                {font.name}
                              </option>
                            );
                          })}
                        </select>
                        <label>Font Size</label>
                        <input
                          style={{ width: "300px" }}
                          type="number"
                          value={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.fontSize
                          }
                          onChange={(e) => {
                            setFontSize(e, "mobile");
                          }}
                        />

                        <label>Font Bold</label>

                        <input
                          type="checkbox"
                          name="fontWeight"
                          checked={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.fontBold
                          }
                          onChange={(e) => {
                            setFontWeight(e, "mobile");
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="padding-section"
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  <div className="heading">Header Background</div>
                </div>
                <div
                  className="d-flex modalContentWrapper"
                  style={{ columnGap: "5px" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Desktop</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div className="d-block">
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Background Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemHeader.desktopStyle.backgroundColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setHeaderBackgroundColor(e, "desktop");
                            }}
                          />
                        </div>

                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Expanded Background Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemHeader.desktopStyle.expandedBackgroundColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setExpandedHeaderBackgroundColor(e, "desktop");
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Mobile</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div className="d-block">
                        {" "}
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Background Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemHeader.mobileStyle.backgroundColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setHeaderBackgroundColor(e, "mobile");
                            }}
                          />
                        </div>
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Expanded Background Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemHeader.mobileStyle.expandedBackgroundColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setExpandedHeaderBackgroundColor(e, "mobile");
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="padding-section"
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  <div className="heading">Header Border</div>
                </div>
                <div
                  className="modalContentWrapper"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="heading-row">Desktop</div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="options"
                  >
                    <div
                      style={{
                        marginTop: "20px",
                        width: "300px",
                      }}
                    >
                      <ColorPicker
                        btnLabel="Border Color"
                        colorValue={
                          props.element.columnSettings[props.accordionItem]
                            .itemHeader.desktopStyle.borderColor
                        }
                        colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                        getColor={(e) => {
                          setHeaderBorderColor(e, "desktop");
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginLeft: "20px",
                        marginRight: "20px",
                      }}
                    >
                      <Counter
                        label="Border Width"
                        minusClick={(e) =>
                          setBorderWidth(e, "desktop", "minus")
                        }
                        valueContent={
                          props.element.columnSettings[props.accordionItem]
                            .itemHeader.desktopStyle.borderWidth
                        }
                        disabled={false}
                        onChange={(e) => {
                          setBorderWidth(e, "desktop");
                        }}
                        plusClick={(e) => setBorderWidth(e, "desktop", "plus")}
                      />
                    </div>
                    <Counter
                      label="Border Radius"
                      minusClick={(e) => setBorderRadius(e, "desktop", "minus")}
                      valueContent={
                        props.element.columnSettings[props.accordionItem]
                          .itemHeader.desktopStyle.borderRadius
                      }
                      disabled={false}
                      onChange={(e) => {
                        setBorderRadius(e, "desktop");
                      }}
                      plusClick={(e) => setBorderRadius(e, "desktop", "plus")}
                    />
                  </div>
                  <div className="heading-row">Mobile</div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="options"
                  >
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div
                        style={{
                          marginTop: "20px",
                          width: "300px",
                        }}
                      >
                        <ColorPicker
                          btnLabel="Border Color"
                          colorValue={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.borderColor
                          }
                          colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                          getColor={(e) => {
                            setHeaderBorderColor(e, "mobile");
                          }}
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: "20px",
                          marginRight: "20px",
                        }}
                      >
                        {" "}
                        <Counter
                          label="Border Width"
                          minusClick={(e) =>
                            setBorderWidth(e, "mobile", "minus")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.borderWidth
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBorderWidth(e, "mobile");
                          }}
                          plusClick={(e) => setBorderWidth(e, "mobile", "plus")}
                        />
                      </div>

                      <Counter
                        label="Border Radius"
                        minusClick={(e) =>
                          setBorderRadius(e, "mobile", "minus")
                        }
                        valueContent={
                          props.element.columnSettings[props.accordionItem]
                            .itemHeader.mobileStyle.borderRadius
                        }
                        disabled={false}
                        onChange={(e) => {
                          setBorderRadius(e, "mobile");
                        }}
                        plusClick={(e) => setBorderRadius(e, "mobile", "plus")}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="padding-section"
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  <div className="heading">Header Padding</div>
                </div>
                <div
                  className="heading-row modalContentWrapper"
                  style={{ justifyContent: "flex-end" }}
                >
                  <UnitSelector
                    defaultValue={
                      props.element.columnSettings[props.accordionItem]
                        .itemHeader.paddingUnit
                    }
                    onChange={toggleHeaderPaddingUnit}
                    value={
                      props.element.columnSettings[props.accordionItem]
                        .itemHeader.paddingUnit
                    }
                  />
                </div>
                <div
                  className="d-flex modalContentWrapper"
                  style={{ columnGap: "5px" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Desktop</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Top"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "minus",
                              "paddingTop"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.paddingTop
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "desktop", "", "paddingTop");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(e, "desktop", "plus", "paddingTop")
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Left"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "minus",
                              "paddingLeft"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.paddingLeft
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "desktop", "", "paddingLeft");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "plus",
                              "paddingLeft"
                            )
                          }
                        />
                      </div>
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Bottom"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "minus",
                              "paddingBottom"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.paddingBottom
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "desktop", "", "paddingBottom");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "plus",
                              "paddingBottom"
                            )
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Right"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "minus",
                              "paddingRight"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.desktopStyle.paddingRight
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "desktop", "", "paddingRight");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "desktop",
                              "plus",
                              "paddingRight"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Mobile</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Top"
                          minusClick={(e) =>
                            setHeaderPadding(e, "mobile", "minus", "paddingTop")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.paddingTop
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "mobile", "", "paddingTop");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(e, "mobile", "plus", "paddingTop")
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Left"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "mobile",
                              "minus",
                              "paddingLeft"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.paddingLeft
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "mobile", "", "paddingLeft");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(e, "mobile", "plus", "paddingLeft")
                          }
                        />
                      </div>
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Bottom"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "mobile",
                              "minus",
                              "paddingBottom"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.paddingBottom
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "mobile", "", "paddingBottom");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "mobile",
                              "plus",
                              "paddingBottom"
                            )
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Right"
                          minusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "mobile",
                              "minus",
                              "paddingRight"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemHeader.mobileStyle.paddingRight
                          }
                          disabled={false}
                          onChange={(e) => {
                            setHeaderPadding(e, "mobile", "", "paddingRight");
                          }}
                          plusClick={(e) =>
                            setHeaderPadding(
                              e,
                              "mobile",
                              "plus",
                              "paddingRight"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div className="modalScrollContainerSecondary">
                <div
                  className="padding-section"
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  <div className="heading">Body Background</div>
                </div>
                <div
                  className="d-flex modalContentWrapper"
                  style={{ columnGap: "5px" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Desktop</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div className="d-block">
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Background Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemBody.desktopStyle.backgroundColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setBodyBackgroundColor(e, "desktop");
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Mobile</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div className="d-block">
                        {" "}
                        <div
                          style={{
                            marginTop: "20px",
                            width: "300px",
                          }}
                        >
                          <ColorPicker
                            btnLabel="Background Color"
                            colorValue={
                              props.element.columnSettings[props.accordionItem]
                                .itemBody.mobileStyle.backgroundColor
                            }
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                            getColor={(e) => {
                              setBodyBackgroundColor(e, "mobile");
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="padding-section"
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  <div className="heading">Body Padding</div>
                </div>
                <div
                  className="heading-row modalContentWrapper"
                  style={{ justifyContent: "flex-end" }}
                >
                  <UnitSelector
                    defaultValue={
                      props.element.columnSettings[props.accordionItem].itemBody
                        .paddingUnit
                    }
                    onChange={toggleBodyPaddingUnit}
                    value={
                      props.element.columnSettings[props.accordionItem].itemBody
                        .paddingUnit
                    }
                  />
                </div>
                <div
                  className="d-flex modalContentWrapper"
                  style={{ columnGap: "5px" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Desktop</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Top"
                          minusClick={(e) =>
                            setBodyPadding(e, "desktop", "minus", "paddingTop")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.desktopStyle.paddingTop
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "desktop", "", "paddingTop");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "desktop", "plus", "paddingTop")
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Left"
                          minusClick={(e) =>
                            setBodyPadding(e, "desktop", "minus", "paddingLeft")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.desktopStyle.paddingLeft
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "desktop", "", "paddingLeft");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "desktop", "plus", "paddingLeft")
                          }
                        />
                      </div>
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Bottom"
                          minusClick={(e) =>
                            setBodyPadding(
                              e,
                              "desktop",
                              "minus",
                              "paddingBottom"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.desktopStyle.paddingBottom
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "desktop", "", "paddingBottom");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(
                              e,
                              "desktop",
                              "plus",
                              "paddingBottom"
                            )
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Right"
                          minusClick={(e) =>
                            setBodyPadding(
                              e,
                              "desktop",
                              "minus",
                              "paddingRight"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.desktopStyle.paddingRight
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "desktop", "", "paddingRight");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "desktop", "plus", "paddingRight")
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Mobile</div>
                    <div
                      style={{ display: "flex", flexDirection: "row" }}
                      className="options"
                    >
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Top"
                          minusClick={(e) =>
                            setBodyPadding(e, "mobile", "minus", "paddingTop")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.mobileStyle.paddingTop
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "mobile", "", "paddingTop");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "mobile", "plus", "paddingTop")
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Left"
                          minusClick={(e) =>
                            setBodyPadding(e, "mobile", "minus", "paddingLeft")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.mobileStyle.paddingLeft
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "mobile", "", "paddingLeft");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "mobile", "plus", "paddingLeft")
                          }
                        />
                      </div>
                      <div style={{ marginRight: "20px" }}>
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Bottom"
                          minusClick={(e) =>
                            setBodyPadding(
                              e,
                              "mobile",
                              "minus",
                              "paddingBottom"
                            )
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.mobileStyle.paddingBottom
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "mobile", "", "paddingBottom");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "mobile", "plus", "paddingBottom")
                          }
                        />
                        <Counter
                          small={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          label="Right"
                          minusClick={(e) =>
                            setBodyPadding(e, "mobile", "minus", "paddingRight")
                          }
                          valueContent={
                            props.element.columnSettings[props.accordionItem]
                              .itemBody.mobileStyle.paddingRight
                          }
                          disabled={false}
                          onChange={(e) => {
                            setBodyPadding(e, "mobile", "", "paddingRight");
                          }}
                          plusClick={(e) =>
                            setBodyPadding(e, "mobile", "plus", "paddingRight")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </Popup>
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccordionItemSettings);
